export type NotificationStatus = "unread" | "read" | "archived";

export type JobStatus = "completed" | "failed";

export type SharedResourceType = "system" | "file" | "model" | "artifact";

export type SharedRole = "editor" | "viewer";

interface NotificationBase {
  id: string;
  createdAt: Date;
  status: NotificationStatus;
  triggeredBy: {
    userId: string;
    displayName: string;
  };
}

export interface JobNotification extends NotificationBase {
  type: "job";
  payload: {
    jobId: string;
    jobStatus: JobStatus;
    systemName?: string;
    functionName: string;
  };
}

export interface ResourceSharedNotification extends NotificationBase {
  type: "share";
  payload: {
    resourceType: SharedResourceType;
    resourceId: string;
    resourceName: string;
    role: SharedRole;
    shareCount: number;
  };
}

export type Notification = JobNotification | ResourceSharedNotification;

export function getNotificationUrl(notification: Notification): string {
  switch (notification.type) {
    case "job":
      return `/jobs/${notification.payload.jobId}`;
    case "share": {
      const { resourceType, resourceId } = notification.payload;
      if (resourceType === "system") return `/systems/${resourceId}`;
      if (resourceType === "artifact") return `/files/artifact/${resourceId}`;
      return `/files/${resourceId}`;
    }
  }
}

export function getNotificationToastTitle(notification: Notification): string {
  switch (notification.type) {
    case "job":
      return notification.payload.jobStatus === "completed" ? "Job completed" : "Job failed";
    case "share":
      return notification.payload.resourceType === "system" ? "System shared with you" : "File shared with you";
  }
}

export function getNotificationToastDescription(notification: Notification): string {
  switch (notification.type) {
    case "job":
      return notification.payload.functionName;
    case "share":
      return `${notification.triggeredBy.displayName} shared ${notification.payload.resourceName}`;
  }
}
